import groupplaceholder from '@/assets/images/groupplaceholder.png'
import shareLink from '@/assets/images/share-link.png'
import shareWhatsApp from '@/assets/images/share-whatsapp.png'
import shareTelegram from '@/assets/images/share-telegram.png'
import shareFacebook from '@/assets/images/share-facebook.png'
import shareLinkedIn from '@/assets/images/share-linkedin.png'

// Vuex
import { mapState } from 'vuex'

// Utilitários
import { valueToTime, canAddUserShift } from '@/functions'

// Components
import ModalTimesheet from '@/modals/timesheet'
// import TimeSheetModalComponent from '@/modals/TimeSheetModalComponent'
import ModalTimesheetSimulation from '@/modals/ModalTimesheetSimulation'
import RelatorioFolhaPagamento from '@/modals/RelatorioFolhaPagamento'
import GroupEditModal from '@/modals/GroupEditModal'

import ReportExport from '@/modals/ReportExport'

import DailyReport from './components/dailyReport'
import GroupTab from '@/components/GroupTab'

import ScaleCreate from '@/modals/ScaleCreate'
import ScaleEdit from '@/modals/ScaleEdit'
import InfoCard from './InfoCard'
import ConfirmDialog from '@/modals/ConfirmDialog'

import SubscriptionModal from '@/modals/SubscriptionModal'

import SosCurrentPlanBadge from '@/components/SosCurrentPlanBadge'
import SosButton from '@/components/SosButton'
import SosSelect from '@/components/SosSelect'

// API
import { apiSetGroupUserLevel, apiRemoveUserFromGroup, apiDeleteScale, apiRenewScaleLink, apiRenewGroupLink } from '@/services/firebase'
import { apiSetWaitingDutyStatus, apiGetGroupStatistics } from '@/services/duties'
import { apiSetUserScales } from '@/services/users'
// import { apiRefOpen, apiRefClose } from '@/services/firebase'

// Mixins
import confirmDialogMixin from '@/mixins/cd.mixin.js'
import stringMixin from '@/mixins/string.mixin.js'
import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'

// Constants
import {
  freeVersion,
  whiteLabel,

  // Base URL to generate GROUP USERS REPORT
  reportUrl,

  // User roles
  MANAGER_USER_ROLE, MEMBER_USER_ROLE, MASTER_USER_ROLE,

  // User capabilities
  GRUPO_ALTERAR_DETALHES_DA_ESCALA, GRUPO_EDITAR_DETALHES, GRUPO_CONVIDAR_USUARIO, GRUPO_NOVA_ESCALA, GRUPO_GERAR_FOLHA_DE_PONTO, GRUPO_SIMULAR_FOLHA_DE_PONTO, GRUPO_FOLHA_DE_PAGAMENTO, GRUPO_VER_TODOS_OS_PLANTOES, GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES, GRUPO_CRIAR_ESCALA, GRUPO_ACOMPANHAR_ESCALA,
  ESCALA_APAGAR, ESCALA_RENOVAR_LINK, ESCALA_COMPARTILHAR, ESCALA_RETIRAR_USUARIO, ESCALA_ALTERAR_PAPEL, ESCALA_VER_PLANTOES_DO_USUARIO,
} from '@/constants'

// Moment JS
import moment from 'moment'
import 'moment/locale/pt-br'
// moment.locale('pt-BR')

//
//
//

const itemsPerPage = 10
const visiblePages = 5

export default {
  name: 'GroupScales',

  components: {
    'report-export': ReportExport,
    'group-tab': GroupTab,
    'relatorio-folha-pagamento': RelatorioFolhaPagamento,
    'daily-report': DailyReport,
    ScaleEdit,
    'confirm-dialog': ConfirmDialog,
    'modal-timesheet': ModalTimesheet,
    ModalTimesheetSimulation,
    'group-edit-modal': GroupEditModal,
    'sos-button': SosButton,
    'info-card': InfoCard,
    'scale-create': ScaleCreate,
    'sos-select': SosSelect,
    'sos-current-plan-badge': SosCurrentPlanBadge,
    'subscription-modal': SubscriptionModal,
  },

  mixins: [
    confirmDialogMixin,
    stringMixin,
    SubscriptionModalMixin,
  ],

  data () {
    return {
      //
      //
      //

      searchQuery: '',
      currentPage: 1,
      filteredItems: [], // Lista de itens filtrados

      //
      //
      //

      // loadingGroupStatistics: 'WAITING',
      // numberOfAvailableDutys: 0,

      //
      //
      //

      freeVersion,
      whiteLabel,

      actionLoading: false,

      //

      shareShiftsVisible: false,

      sheet: false,
      sharedScaleItem: null,

      isAdmin: {},
      isMaster: {},
      allLoadingUsers: {},
      // allMunicipalities: {},

      // activeScaleModal: false,
      groupTab: 'escalas',

      shareTelegram,
      shareLink,
      shareWhatsApp,
      shareLinkedIn,
      shareFacebook,

      //
      //
      //

      loadingReport: 'WAITING',

      btnState: {
        folhaDePagamento: false,
      },

      groupUsersScales: null,

      /**
       *
       * -
       *
       */

      // groupManagersMunicipalities: false,
    }
  },

  computed: {
    ...mapState(['userSession', 'group', 'currentGroupCapabilities', 'plans', 'listeners', 'groupUsers', 'groupScales', 'groupRequestedShifts', 'loadingGroupStatistics', 'numberOfAvailableDutys']),

    //
    //
    //
    // PAGINATION
    //
    //
    //

    // Cálculo da paginação com base nos itens filtrados
    paginatedResults () {
      const start = (this.currentPage - 1) * itemsPerPage
      const end = start + itemsPerPage
      return this.filteredItems.slice(start, end)
    },

    // Total de páginas com base nos itens filtrados
    totalPages () {
      return Math.ceil(this.filteredItems.length / itemsPerPage)
    },

    pageNumbers () {
      const pages = []
      const startPage = Math.max(1, this.currentPage - Math.floor(visiblePages / 2))
      const endPage = Math.min(this.totalPages, startPage + visiblePages - 1)

      // Adiciona as páginas no intervalo
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i)
      }

      // Adiciona o início e o fim das páginas, se necessário
      if (startPage > 1) {
        pages.unshift('...')
        pages.unshift(1)
      }

      if (endPage < this.totalPages) {
        pages.push('...')
        pages.push(this.totalPages)
      }

      return pages
    },

    //
    //
    //

    info1Obj () {
      return {
        description: `${this.numberOfAvailableDutys === 1 ? 'Plantão vazio' : 'Plantões vazios'}`,
        icon: 'mdi-calendar-alert',
        value: this.loadingGroupStatistics === 'DONE' ? this.numberOfAvailableDutys : 0,
        loading: this.loadingGroupStatistics !== 'DONE',
      }
    },

    info2Obj () {
      /* !!this.listeners === true && !!this.listeners.participantsCount === true */
      return {
        description: `${!!this.groupUsers === true && this.groupUsers.length === 1 ? 'Participante' : 'Participantes'}`,
        icon: 'mdi-account-group',
        value: !!this.listeners === true && this.listeners.loadingGroupDetails === 'no' ? this.groupUsers.length : 0,
        loading: !!this.listeners === true && this.listeners.loadingGroupDetails !== 'no',
      }
    },

    info3Obj () {
      return {
        description: 'Realizando plantões no grupo',
        icon: 'mdi-account',
        value: !!this.listeners === true && this.listeners.loadingGroupScales === 'no' ? this.listeners.numberOfPlantonistasOnGroup : 0,
        loading: !!this.listeners === true && this.listeners.loadingGroupScales !== 'no',
      }
    },

    //
    //
    //

    canAttachUserScales () {
      return this.freeVersion === true || this.userSession.userCapabilities.relacionarEscalas === true
    },

    // const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo vincular escalas a um plantonista. Preciso de ajuda." target="_blank">suporte</a>`
    // const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`
    // const textSupport = '<br /><span style="color: yellow">Por favor, verifique a situação do seu plano com o nosso suporte.</span>'

    canAttachUserScalesMessage ()
    {
      let title = ''
      let message = ''
      const planName = this.userSession.planName.name

      if (this.userSession.planOrigin === 'CUSTOM') {
        // Plano personalizado
        title = 'Verifique seu plano:'
        message = `Você está no ${planName} personalizado e não tem permissão para vincular escalas a um plantonista.`
      } else if (this.userSession.planOrigin === 'COUPON') {
        // Cupom ativo
        title = 'Verifique seu plano:'
        message = `Você tem um cupom ativo no ${planName}, mas não tem permissão para vincular escalas a um plantonista.`
      } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
        // Assinatura ativa na vindi
        title = 'Faça um upgrade:'
        message = `Você está no ${planName}. Assine o Plano Platinum para conseguir vincular escalas a um plantonista.`
      } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
        // Assinatura ativa, mas com alguma pendência ou erro na vindi
        title = 'Verifique sua assinatura:'
        message = `Você não tem permissão para vincular escalas a um plantonista, pois você é assinante do ${planName} e ele não está ativo.`
      }
      else
      {
        if (!!this.userSession.vindi === true) {
          // Plano da vindi expirado
          title = 'Verifique sua assinatura:'
          message = `Você não tem permissão para vincular escalas a um plantonista, pois você assinou o ${this.userSession.vindi.planName.name} e ele expirou. Agora você está no ${planName}.`
        } else {
          // Plano gratuíto ou alcançou alguma condição desconhecida
          title = 'Verifique seu plano:'
          message = `Você está no ${planName} e não tem permissão para vincular escalas a um plantonista.`
        }
      }

      return this.canAttachUserScales ? '<span style="font-size: 16px; line-height: 20px">Você pode informar as escalas de um plantonista!</span>' : `<div style="line-height: 0"><div style="margin-bottom: 5px; font-size: 16px; font-weight: bold; line-height: 20px"><i aria-hidden="true" class="mdi mdi-information" style="display: inline-block; vertical-align: top; font-size: 20px"></i>&nbsp;${title}</div><span style="color: #fafad2; font-size: 16px; line-height: 20px">${message}</span></div>`
    },

    canAttachUserScalesStyles ()
    {
      return this.canAttachUserScales ? 'rgba(0, 139, 0, 0.95)' : 'rgba(139, 0, 0, 0.95)'
    },

    //
    // LOADING BAR STEP
    //

    loadingProgress: function () {
      if (!!this.listeners === false || !!this.listeners.loadingGroupDetails === false || !!this.listeners.loadingGroupScales === false || !!this.listeners.loadingRequestedShifts === false) return 0

      let progress = 0

      if (this.listeners.loadingGroupDetails === 'no') progress += 33.333333
      if (this.listeners.loadingGroupScales !== 'yes') progress += 33.333333
      if (this.listeners.loadingRequestedShifts !== 'yes') progress += 33.333333

      return progress
    },

    //
    //
    //

    groupStatistics: function ()
    {
      if (!!this.listeners === false) return []

      const availableShiftsCount = this.listeners.availableShiftsCount || 0
      const ownedShiftsCount = this.listeners.ownedShiftsCount || 0
      const participantsCount = this.listeners.participantsCount || 0

      return [
        {
          id: 1,
          type: 'info',
          description: `${availableShiftsCount === 1 ? 'Plantão vazio' : 'Plantões vazios'}`,
          icon: 'mdi-calendar-alert',
          value: availableShiftsCount,
        },
        {
          id: 2,
          type: 'info',
          description: `${ownedShiftsCount === 1 ? 'Plantão assumido' : 'Plantões assumidos'}`,
          icon: 'mdi-calendar-check',
          value: ownedShiftsCount,
        },
        {
          id: 3,
          type: 'info',
          description: `${participantsCount === 1 ? 'Participante' : 'Participantes'}`,
          icon: 'mdi-account-multiple',
          value: participantsCount,
        },
      ]
    },

    //
    //
    //
    //
    //
    //
    //

    hasWaitingDuties () {
      if (!!this.groupRequestedShifts === false || (!!this.groupRequestedShifts === true && !Array.isArray(this.groupRequestedShifts))) {
        return false
      }

      return this.groupRequestedShifts.length > 0
    },

    haveScales () {
      return !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0
    },

    groupImage () {
      return this.$store.state.group.img || groupplaceholder
    },

    groupID () {
      return this.$route.params.groupID
    },

    //
    // PERMISSIONS
    //

    groupActions () {
      const actions = []
      if (this.currentGroupCapabilities) {
        if (this.currentGroupCapabilities[GRUPO_CONVIDAR_USUARIO]) {
          actions.push({ id: 'TITLE', title: 'Usuários' })
          actions.push({ id: 'INVITE_USER', icon: 'mdi-account-plus', title: 'Convidar usuário' })
        }
        if (this.currentGroupCapabilities[GRUPO_NOVA_ESCALA]) {
          actions.push({ id: 'TITLE', title: 'Escalas' })
          actions.push({ id: 'NEW_SCALE', icon: 'mdi-calendar-plus', title: 'Nova escala' })
        }
        if (this.currentGroupCapabilities[GRUPO_GERAR_FOLHA_DE_PONTO] || this.currentGroupCapabilities[GRUPO_SIMULAR_FOLHA_DE_PONTO] || this.currentGroupCapabilities[GRUPO_FOLHA_DE_PAGAMENTO]) actions.push({ id: 'TITLE', title: 'Relatórios' })
        if (this.currentGroupCapabilities[GRUPO_GERAR_FOLHA_DE_PONTO]) actions.push({ id: 'PAYROLL_GENERATE', icon: 'mdi-account-clock-outline', title: 'Gerar folha de ponto' })
        if (this.currentGroupCapabilities[GRUPO_SIMULAR_FOLHA_DE_PONTO]) actions.push({ id: 'PAYROLL_SIMULATE', icon: 'mdi-timer-refresh-outline', title: 'Simular folha de ponto' })
        if (this.currentGroupCapabilities[GRUPO_FOLHA_DE_PAGAMENTO]) actions.push({ id: 'PAYROLL_1.0', icon: 'mdi-account-cash', title: 'Folha de pagamento' })
        if (this.currentGroupCapabilities[GRUPO_VER_TODOS_OS_PLANTOES] || this.currentGroupCapabilities[GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]) actions.push({ id: 'TITLE', title: 'Plantões' })
        if (this.currentGroupCapabilities[GRUPO_VER_TODOS_OS_PLANTOES]) actions.push({ id: 'GROUP_SHIFTS_SHOW', icon: 'mdi-magnify', title: 'Ver todos os plantões' })
        if (this.currentGroupCapabilities[GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]) actions.push({ id: 'GROUP_LINK_RENEWAL_CODE', icon: 'mdi-refresh', title: 'Renovar link do grupo' })
        if (this.currentGroupCapabilities[GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]) actions.push({ id: 'GROUP_SHIFTS_SHARE', icon: 'mdi-share-variant-outline', title: 'Compartilhar todos os plantões' })
      }
      return actions
    },

    permissaoAcoesDoGrupo () {
      if (this.currentGroupCapabilities) {
        return this.currentGroupCapabilities[GRUPO_CONVIDAR_USUARIO] ||
          this.currentGroupCapabilities[GRUPO_NOVA_ESCALA] ||
          this.currentGroupCapabilities[GRUPO_GERAR_FOLHA_DE_PONTO] ||
          this.currentGroupCapabilities[GRUPO_SIMULAR_FOLHA_DE_PONTO] ||
          this.currentGroupCapabilities[GRUPO_FOLHA_DE_PAGAMENTO] ||
          this.currentGroupCapabilities[GRUPO_VER_TODOS_OS_PLANTOES] ||
          this.currentGroupCapabilities[GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES]
      }
      return false
    },

    permissaoNovaEscala () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_NOVA_ESCALA] === true
    },

    permissaoGrupoAlterarDetalhesDaEscala () {
      // console.log('::: permissaoGrupoAlterarDetalhesDaEscala:', this.currentGroupCapabilities, GRUPO_ALTERAR_DETALHES_DA_ESCALA, !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_ALTERAR_DETALHES_DA_ESCALA] === true)
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_ALTERAR_DETALHES_DA_ESCALA] === true
    },

    permissaoGrupoEditarDetalhes () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_EDITAR_DETALHES] === true
    },

    permissaoGrupoCriarEscala () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_CRIAR_ESCALA] === true
    },

    permissaoGrupoAcompanharEscala () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_ACOMPANHAR_ESCALA] === true
    },

    permissaoAcoesEscala () {
      return !!this.currentGroupCapabilities === true && (
        this.currentGroupCapabilities[ESCALA_APAGAR] ||
        this.currentGroupCapabilities[ESCALA_RENOVAR_LINK] ||
        this.currentGroupCapabilities[ESCALA_COMPARTILHAR]
      )
    },

    /* permissaoEscalaApagar () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_APAGAR] === true
    },

    permissaoEscalaRenovarLink () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_RENOVAR_LINK] === true
    },

    permissaoEscalaCompartilhar () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_COMPARTILHAR] === true
    }, */

    permissaoEscalaRetirarUsuario () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_RETIRAR_USUARIO] === true
    },

    permissaoEscalaAlterarPapel () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_ALTERAR_PAPEL] === true
    },

    permissaoEscalaVerPlantoesDoUsuario () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_VER_PLANTOES_DO_USUARIO] === true
    },
  },

  watch: {
    /* '$store.state.group': function () {
      if (!!this.$store.state.group === true && !!this.$store.state.group.users === true) {
        const groupUsers = this.$store.state.group.users
        const usersKeys = Object.keys(groupUsers)

        this.isAdmin = Object.fromEntries(usersKeys.map(userItem => {
          return !!userItem === true ? [userItem, groupUsers[userItem].admin || false] : [userItem, false]
        }).filter(userValidate => !!userValidate === true))

        this.isMaster = Object.fromEntries(usersKeys.map(userItem => {
          return !!userItem === true ? [userItem, groupUsers[userItem].master || false] : [userItem, false]
        }).filter(userValidate => !!userValidate === true))

        this.allLoadingUsers = Object.fromEntries(usersKeys.map(userItem => {
          return !!userItem === true ? [userItem, false] : [userItem, false]
        }).filter(userValidate => !!userValidate === true))

        // [24/01/25] console.log('::: watch[isAdmin]:', this.isAdmin, this.isMaster, this.allLoadingUsers)
      }

      // group.users[userItem.userID]
      // [24/01/25] console.log('::: watch[group]:', this.$store.state.group)
    }, */

    //
    // SEM ISSO, A BUSCA DE USUÁRIOS NÃO FUNCIONARÁ ALÉM DA PRIMEIRA PÁGINA
    //

    '$store.state.listeners.loadingGroupDetails': {
      immediate: true,
      handler (statusNew, statusOld) {
        // [24/01/25] console.log('::: GROUP > watch > loadingGroupDetails:', statusNew)

        // Inicializa os itens filtrados com todos os itens
        if (statusNew === 'no') this.filteredItems = this.groupUsers
      },
    },

    //
    //
    //

    groupUsers: {
      immediate: true,
      deep: true,

      handler (dataNew, dataOld)
      {
        // [24/01/25] console.log('::: GROUP USERS:', dataNew.length)

        const groupScales = !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0 ? this.groupScales : []

        if (!!dataNew === true && Array.isArray(dataNew) && dataNew.length > 0 /* && groupScales.length > 0 */)
        {
          // [24/01/25] console.log('::: [NEW] groupUsers:', dataNew)

          //
          //
          //

          this.isAdmin = { ...Object.fromEntries(dataNew.map(u => ([u.userID, u.isAdmin])).filter(c => !!c === true)) }
          this.isMaster = { ...Object.fromEntries(dataNew.map(u => ([u.userID, u.isMaster])).filter(c => !!c === true)) }
          //
          this.allLoadingUsers = { ...Object.fromEntries(dataNew.map(u => ([u.userID, false])).filter(c => !!c === true)) }

          //
          //
          //

          this.groupUsersScales = Object.fromEntries(
            dataNew.map(groupUser => {
              if (!!this.allLoadingUsers[groupUser.userID] === true) this.allLoadingUsers[groupUser.userID] = false

              return [
                groupUser.userID,
                groupScales.length > 0 ? [
                  // LISTA DE ESCALAS DO USUÁRIO
                  ...groupScales.map(groupScale => ({
                    key: `user_scale_${groupScale.scaleID}_${groupUser.userID}`,
                    value: `${groupScale.scaleID}_${groupUser.userID}`,
                    rawText: groupScale.scaleName,
                    text: groupScale.scaleName,
                    checked: groupScale.scaleRelatedUsers.some(userID => userID === groupUser.userID),
                    payload: { scaleID: groupScale.scaleID, userID: groupUser.userID },
                  })),
                ] : [],
              ]
            })
          )

          //
          // Atualiza lista de usuários após alguma alteração nos USUÁRIOS DO GRUPO (Ex: Retirada)
          // JESUS: Testar em grupos grandes
          //

          this.filterItems()
        }
      },
    },

    //
    //
    //

    groupScales: {
      immediate: true,
      deep: true,

      handler (dataNew, dataOld)
      {
        if (!!dataNew === true && Array.isArray(dataNew) && dataNew.length > 0 && this.groupUsers.length > 0)
        {
          // [24/01/25] console.log('::: [NEW] groupScales:', dataNew)

          //
          //
          //

          this.isAdmin = { ...Object.fromEntries(this.groupUsers.map(u => ([u.userID, u.isAdmin])).filter(c => !!c === true)) }
          this.isMaster = { ...Object.fromEntries(this.groupUsers.map(u => ([u.userID, u.isMaster])).filter(c => !!c === true)) }
          //
          this.allLoadingUsers = { ...Object.fromEntries(this.groupUsers.map(u => ([u.userID, false])).filter(c => !!c === true)) }

          //
          //
          //

          this.groupUsersScales = Object.fromEntries(
            this.groupUsers.map(groupUser => {
              if (!!this.allLoadingUsers[groupUser.userID] === true) this.allLoadingUsers[groupUser.userID] = false

              return [
                groupUser.userID,
                dataNew.length > 0 ? [
                  // LISTA DE ESCALAS DO USUÁRIO
                  ...dataNew.map(groupScale => ({
                    key: `user_scale_${groupScale.scaleID}_${groupUser.userID}`,
                    value: `${groupScale.scaleID}_${groupUser.userID}`,
                    rawText: groupScale.scaleName,
                    text: groupScale.scaleName,
                    checked: groupScale.scaleRelatedUsers.some(userID => userID === groupUser.userID),
                    payload: { scaleID: groupScale.scaleID, userID: groupUser.userID },
                  })),
                ] : [],
              ]
            })
          )
        }
      },
    },
  },

  async mounted ()
  {
    const { groupID } = this.$route.params

    // [24/01/25] console.log('::: GROUP PAGE IS MOUNTED:', groupID)

    this.$store.dispatch('loadGroupPage', groupID)

    if (this.loadingGroupStatistics !== 'DONE') await this.loadGroupStatistics()

    //
    // moment init

    moment.locale('pt-BR')

    //
    // JESUS
    // JESUS
    // JESUS
    //

    if (!!this.$store.state.group === true && !!this.$store.state.group.users === true)
    {
      const groupUsers = this.$store.state.group.users
      const usersKeys = Object.keys(groupUsers)

      this.isAdmin = { ...Object.fromEntries(usersKeys.map(u => (!!u === true && !!groupUsers[u] === true ? [u, groupUsers[u].admin || false] : [u, false])).filter(c => !!c === true)) }
      this.isMaster = { ...Object.fromEntries(usersKeys.map(u => (!!u === true && !!groupUsers[u] === true ? [u, groupUsers[u].master || false] : [u, false])).filter(c => !!c === true)) }
      this.allLoadingUsers = { ...Object.fromEntries(usersKeys.map(u => ([u, false])).filter(c => !!c === true)) }

      // [24/01/25] console.log('::: mounted[isAdmin]:', this.isAdmin, this.isMaster, this.allLoadingUsers)
    }

    // [24/01/25] console.log('::: mounted[group]:', this.$store.state.group)
  },

  methods: {
    dailyReportLoadingStatus (status)
    {
      this.loadingReport = status ? 'LOADING' : 'DONE'
    },

    //
    //
    //

    handleSearch (event) {
      this.searchQuery = String(event.target.value).trim()
      this.filterItems() // Atualiza a lista filtrada
      this.currentPage = 1 // Reinicia a página ao mudar o termo de busca
    },

    // Filtra os itens com base no termo de busca
    filterItems () {
      if (this.searchQuery.length < 3) {
        this.filteredItems = [...this.groupUsers]
        return false
      }

      const searchQuery = this.searchQuery.toLowerCase()

      this.filteredItems = [...this.groupUsers.filter(user => !!user.backup === true && (String(user.backup.nome || '').trim().toLowerCase().includes(searchQuery) || String(user.backup.email || '').trim().toLowerCase().includes(searchQuery)))]
    },

    // Avança para a próxima página
    nextPage () {
      if (this.currentPage < this.totalPages) this.currentPage++
    },

    // Retorna para a página anterior
    previousPage () {
      if (this.currentPage > 1) this.currentPage--
    },

    setPage (currentPage) {
      this.currentPage = parseInt(currentPage)
    },

    //
    //
    //

    async loadGroupStatistics ()
    {
      if (this.loadingGroupStatistics === 'LOADING') return false

      // this.loadingGroupStatistics = 'LOADING'
      this.$store.commit('SET_GROUP_AVAILABLE_DUTIES_AMOUNT_STATUS', 'LOADING')

      const groupDuties = await apiGetGroupStatistics(this.$route.params.groupID)
      const numberOfAvailableDutys = groupDuties.filter(([_, duty]) => !!duty === true && !!duty.status === true && Object.prototype.hasOwnProperty.call(duty, 'uid_pegou') && String(duty.status) === 'aberto' && String(duty.uid_pegou) === '0').length

      this.$store.commit('SET_GROUP_AVAILABLE_DUTIES_AMOUNT', numberOfAvailableDutys)

      // this.loadingGroupStatistics = 'DONE'
    },

    //
    //
    //

    userActions (u)
    {
      const loggedUserId = !!this.$store.state.userSession === true && !!this.$store.state.userSession.uid === true ? this.$store.state.userSession.uid : ''

      const output = []

      if (this.permissaoEscalaVerPlantoesDoUsuario) output.push({ id: 'USER_DUTIES', icon: 'mdi-magnify', title: 'Ver plantões', payload: u })
      if (
        this.permissaoEscalaRetirarUsuario && (
          !!u === false || (
            u.userID !== (this.userSession.uid || '') /* !u.isMe */ && (!!this.isMaster[u.userID] === false || (!!this.isMaster[u.userID] === true && this.isMaster[loggedUserId] === true))
          )
        )
      ) output.push({ id: 'KICK_USER', icon: 'mdi-account-off', title: 'Retirar do grupo', payload: u })

      return output
    },

    //
    //
    //

    scaleActions (scaleItem) {
      const actions = []
      if (this.currentGroupCapabilities) {
        // if (this.currentGroupCapabilities[ESCALA_APAGAR] || this.currentGroupCapabilities[ESCALA_RENOVAR_LINK] || this.currentGroupCapabilities[ESCALA_COMPARTILHAR]) actions.push({ id: 'TITLE', title: 'Ações da escala' })
        if (this.currentGroupCapabilities[ESCALA_APAGAR]) actions.push({ id: 'DELETE_SCALE', icon: 'mdi-trash-can', title: 'Apagar escala', payload: scaleItem })
        if (this.currentGroupCapabilities[ESCALA_RENOVAR_LINK]) actions.push({ id: 'RENEW_SCALE_LINK', icon: 'mdi-refresh', title: 'Renovar link da escala', payload: scaleItem })
        if (this.currentGroupCapabilities[ESCALA_COMPARTILHAR]) actions.push({ id: 'SHARE_SCALE', icon: 'mdi-share-variant-outline', title: 'Compartilhar escala', payload: scaleItem })
      }
      return actions
    },

    /**
     *
     * DAILY REPORT - METHODS
     *
     */

    //

    /**
     *
     * OPEN "GROUP EDIT" MODAL
     *
     */

    openGroupEditModal (selectedGroup) {
      this.$refs.mdGroupEditModal.open(selectedGroup)
    },

    closeGroupEditModal (type) {
      // [24/01/25] console.log('::: closeGroupEditModal[type]:', type)
    },

    /**
     *
     * COPIAR LINK "COMPARTILHAR PLANTÕES DO GRUPO"
     *
     */

    onClickCopiarLinkPlantoes () {
      const text = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`

      const $this = this

      navigator.clipboard.writeText(text).then(function () {
        // [24/01/25] console.log('onClickCopiarLink:', text)
        // alert('Link copiado com sucesso!')
        $this.shareShiftsVisible = false
      }, function () {
        alert('Não foi possível copiar o link')
      })
    },

    onClickWhatsAppPlantoes () {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`
      const text = `Olá! Clique no link para ver os plantões do grupo ${this.group.nome} no SOS Gestor.\n ${scaleURL}`
      const URL = `https://wa.me/?text=${text}`

      this.shareShiftsVisible = false

      window.open(URL, '_blank')
    },

    onClickTelegramPlantoes () {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`
      const text = encodeURIComponent(`Olá! Clique no link para ver os plantões do grupo ${this.group.nome} no SOS Gestor.`)
      const URL = `https://t.me/share/url?url=${scaleURL}&text=${text}`

      this.shareShiftsVisible = false

      window.open(URL, '_blank')
    },

    onClickFacebookPlantoes () {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`
      const URL = `https://facebook.com/sharer/sharer.php?u=${scaleURL}`

      this.shareShiftsVisible = false

      window.open(URL, '_blank')
    },

    onClickLinkedInPlantoes () {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}plantoes/link/${this.$route.params.groupID}/${this.group.groupShareCode}`
      const URL = `https://www.linkedin.com/shareArticle?mini=true&url=${scaleURL}`

      this.shareShiftsVisible = false

      window.open(URL, '_blank')
    },

    /**
     *
     * ?
     *
     */

    onClickCopiarLink (scale) {
      const text = `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`

      const $this = this

      navigator.clipboard.writeText(text).then(function () {
        // [24/01/25] console.log('onClickCopiarLink:', text)
        // alert('Link copiado com sucesso!')
        $this.sheet = false
        $this.sharedScaleItem = null
      }, function () {
        alert('Não foi possível copiar o link')
      })
    },

    onClickWhatsApp (scale) {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`
      const text = `Olá! Clique no link para participar da escala ${scale.scaleName} no SOS Gestor.\n ${scaleURL}`
      const URL = `https://wa.me/?text=${text}`

      this.sheet = false
      this.sharedScaleItem = null

      window.open(URL, '_blank')
    },

    onClickTelegram (scale) {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`
      const text = encodeURIComponent(`Olá! Clique no link para participar da escala ${scale.scaleName} no SOS Gestor.`)
      const URL = `https://t.me/share/url?url=${scaleURL}&text=${text}`

      this.sheet = false
      this.sharedScaleItem = null

      window.open(URL, '_blank')
    },

    onClickFacebook (scale) {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`
      const URL = `https://facebook.com/sharer/sharer.php?u=${scaleURL}`

      this.sheet = false
      this.sharedScaleItem = null

      window.open(URL, '_blank')
    },

    onClickLinkedIn (scale) {
      const scaleURL = `${process.env.VUE_APP_BASE_URL}escala/link/${this.$route.params.groupID}/${scale.scaleID}/${scale.scaleCode}`
      const URL = `https://www.linkedin.com/shareArticle?mini=true&url=${scaleURL}`

      this.sheet = false
      this.sharedScaleItem = null

      window.open(URL, '_blank')
    },

    /**
     *
     * ?
     *
     */

    shareScale (scale) {
      if (!!scale.scaleCode === false) return this.showMessage('Atenção!', '<b style="color: dodgerblue; font-size: 18px; line-height: 1">Atualização em 18/10/2024:</b><br /><br />Agora os gestores podem bloquear os links compartilhados.<br /><br /><b style="color: dodgerblue; font-size: 18px; line-height: 1">Instrução para compartilhar:</b><br /><br />Essa escala ainda não está protegida, então clique na ação <b>Renovar link da escala</b> e depois compartilhe o link para os usuários.')

      this.sheet = true
      this.sharedScaleItem = scale
    },

    //
    //
    //

    setPayrollButtonState (state) {
      this.btnState.folhaDePagamento = state
    },

    //
    //
    //

    onGroupActionClick (action)
    {
      //
      // USUÁRIOS
      //

      // INVITE USER
      if (action.id === 'INVITE_USER') this.$router.push(`/admin/grupos/${this.$route.params.groupID}/convidar`)

      // console.log(`::: ENTRANDO NA PÁGINA DE CONVITE ATRAVÉS DA PÁGINA DO GRUPO "${this.$route.params.groupID}"`)

      //
      // ESCALAS
      //

      // NEW SCALE
      if (action.id === 'NEW_SCALE') this.openScaleCreateModal(this.group)

      //
      // RELATÓRIOS
      //

      // OPEN "TIMESHEET GENERATOR" MODAL
      if (action.id === 'PAYROLL_GENERATE') this.$refs.mdTimesheetReport.open()

      // OPEN "TIMESHEET SIMULATOR" MODAL
      if (action.id === 'PAYROLL_SIMULATE') this.$refs.mdTimesheetSimulationReport.open()

      // -
      if (action.id === 'PAYROLL_1.0') {
        this.$refs.dialogFolhaDePagamento.open('NO', 'NO')
      }

      //
      // PLANTÕES
      //

      // RENOVAR LINK DO GRUPO
      if (action.id === 'GROUP_LINK_RENEWAL_CODE')
      {
        this.showDialog('Atenção!', 'O link atual do grupo' + (!!this.group.groupName === true ? ` "<i><b style="color: green; word-break: break-all">${this.group.groupName}</b></i>" ` : ' ') + 'vai expirar.<br><br><b style="color: indianred">ENVIE O NOVO LINK PARA A SUA EQUIPE APÓS CONFIRMAR A OPERAÇÃO!</b><br><br><b>Deseja continuar?</b>', 'groupLinkRenewal', '')
      }

      // SHARE GROUP SHIFTS
      if (action.id === 'GROUP_SHIFTS_SHARE')
      {
        if (!!this.group.groupShareCode === false)
        {
          this.showMessage('Atenção!', '<b style="color: dodgerblue; font-size: 18px; line-height: 1">Atualização em 01/11/2024:</b><br /><br />Agora os gestores podem bloquear os links compartilhados.<br /><br /><b style="color: dodgerblue; font-size: 18px; line-height: 1">Instrução para compartilhar:</b><br /><br />O link do grupo ainda não está protegido, então clique na ação <b>Renovar link do grupo</b> e depois compartilhe o link para os usuários.')
        }
        else
        {
          this.shareShiftsVisible = true
        }
      }

      // VIEW ALL GROUP SHIFTS
      if (action.id === 'GROUP_SHIFTS_SHOW') this.$router.push(`/admin/grupos/${this.$route.params.groupID}/plantoes`)
    },

    //
    //
    //

    onUserActionClick (action)
    {
      // USER_DUTIES
      // sos-button(@buttonClick="openUserTurns(userItem.userID)" color="purple" buttonLabel="Ver plantões" buttonIcon="mdi-magnify" buttonIconSize="16" :disabled="allLoadingUsers[userItem.userID]").mr-1

      // KICK_USER
      // sos-button(@buttonClick="kickUserConfirm(userItem.userID, userItem.isMe, userItem.userNameAbrev)" color="danger" buttonLabel="Retirar" buttonIcon="mdi-account-off" buttonIconSize="16" :disabled="allLoadingUsers[userItem.userID] || userItem.isMe")

      if (action.id === 'USER_DUTIES') this.openUserTurns(action.payload.userID)

      if (action.id === 'KICK_USER') this.kickUserConfirm(action.payload.userID, action.payload.userID === (this.userSession.uid || '') /* action.payload.isMe */, action.payload.userNameAbrev)
    },

    onScaleActionClick (action)
    {
      if (action.id === 'DELETE_SCALE') this.confirmScaleDelete(action.payload)

      if (action.id === 'RENEW_SCALE_LINK') this.confirmScaleLinkRenew(action.payload)

      if (action.id === 'SHARE_SCALE') this.shareScale(action.payload)
    },

    goToScale (scaleID) {
      this.$router.push(`/admin/grupos/${this.$route.params.groupID}/escalas/${scaleID}`)
    },

    goToEditScale (scaleID) {
      this.$router.push(`/admin/grupos/${this.$route.params.groupID}/escalas/${scaleID}/editar`)
    },

    /**
     *
     * ?
     *
     */

    openUserTurns (userID) {
      if (this.actionLoading === true) {
        // [24/01/25] console.log('::: o sistema está ocupado! não pode abrir os plantões do usuário agora...')
        return false
      }

      // console.log('Senhor Jesus:', 'VER PLANTÕES - UserID:', userID)

      /* this.actionLoading = true */
      // [24/01/25] console.log(`::: ENTRANDO NA PÁGINA DE PLANTÕES DO USUÁRIO ATRAVÉS DA PÁGINA DO GRUPO "${this.$route.params.groupID}"`)
      this.$router.push(`/admin/grupos/${this.$route.params.groupID}/usuario/${userID}/plantoes`)
      /* this.actionLoading = false */
    },

    gerUserRoleName (userID) {
      if (this.isMaster[userID] === true) return MASTER_USER_ROLE
      if (this.isAdmin[userID] === true) return MANAGER_USER_ROLE
      return MEMBER_USER_ROLE
    },

    async setAdmin (userID, isMe, userName)
    {
      if (isMe === true) {
        // [24/01/25] console.log('::: você não pode retirar a si mesmo da gestão do grupo')
        return false
      }

      if (this.allLoadingUsers[userID] === true || this.actionLoading === true) {
        // [24/01/25] console.log('::: o sistema está ocupado! não pode definir o papel do usuário...')
        return false
      }

      // const loggedUserId = !!this.userSession === true && !!this.userSession.uid === true ? this.userSession.uid : ''
      const loggedUserId = !!this.$store.state.userSession === true && !!this.$store.state.userSession.uid === true ? this.$store.state.userSession.uid : ''

      // [24/01/25] console.log('::: SET ADMIN > loggedUserId:', loggedUserId)

      // Obtemos os papéis dos usuários para simplificar o acesso
      const userIsMaster = this.isMaster[userID]
      const userIsAdmin = this.isAdmin[userID]
      const loggedUserIsMaster = this.isMaster[loggedUserId]
      const loggedUserIsAdmin = this.isAdmin[loggedUserId]

      if (loggedUserIsAdmin && !loggedUserIsMaster && userIsMaster) {
        return this.showMessage('Aviso', `Você não tem permissão para alterar o papel de <b>${userName}</b>.`)
      }

      // Master -> Membro

      // Definimos os papéis com base nas condições
      const newRolesObj = userIsMaster ? (
        { master: false, admin: false }
      ) : (
        userIsAdmin ? (
          { master: loggedUserIsMaster, admin: loggedUserIsMaster }
        ) : (
          { master: false, admin: loggedUserIsAdmin }
        )
      )

      const { groupID } = this.$route.params

      /* SEM MENSAGEM PARA O GRUPO */
      // targetUserId, nome,

      const processing = true

      /* let processing = true

      if (userIsAdmin === true && newUserIsAdmin === false) {
        // [24/01/25] console.log(`::: RETIRANDO O USUÁRIO ${userID} DA GESTÃO DO GRUPO`)
      } else if (userIsAdmin === false && newUserIsAdmin === true) {
        // [24/01/25] console.log(`::: COLOCANDO O USUÁRIO ${userID} COMO GESTOR DO GRUPO`)
      } else {
        processing = false
        // [24/01/25] console.log(`::: BUG AO DEFINIR PAPEL DO USUÁRIO ${userID}:`, userIsAdmin, newUserIsAdmin)
      } */

      if (processing)
      {
        this.actionLoading = true

        this.allLoadingUsers[userID] = true
        this.allLoadingUsers = { ...this.allLoadingUsers }

        const request = await apiSetGroupUserLevel(groupID, userID, userName, newRolesObj.admin, newRolesObj.master)

        // O checkbox não é revertido...
        // this.isAdmin[userID] = request.code === 0 ? userIsAdmin : newUserIsAdmin
        // this.isMaster[userID] = request.code === 0 ? userIsAdmin : newUserIsAdmin

        this.allLoadingUsers[userID] = false
        this.allLoadingUsers = { ...this.allLoadingUsers }

        this.actionLoading = false

        // [24/01/25] console.log(`::: PAPEL DO USUÁRIO ${userID}:`, this.isAdmin[userID], this.isMaster[userID], request)

        if (request.code === 0) {
          // [24/01/25] console.log(`::: NÃO FOI POSSÍVEL ALTERAR O PAPEL DO USUÁRIO ${userID}:`, this.isAdmin[userID], this.isMaster[userID], request)
        } else {
          this.isMaster[userID] = newRolesObj.master
          this.isAdmin[userID] = newRolesObj.admin
        }
      }
    },

    /**
     *
     * ?
     *
     */

    setTab (tab = 'escalas') {
      this.groupTab = tab
    },

    openGroupDetails () {
      // [24/01/25] console.log(`::: ABRINDO DETALHES DO GRUPO "${this.$route.params.groupID}"`)
    },

    /* handleInviteUsers () {
      // [24/01/25] console.log(`::: ENTRANDO NA PÁGINA DE CONVITE ATRAVÉS DA PÁGINA DO GRUPO "${this.$route.params.groupID}"`)

      this.$router.push(`/admin/grupos/${this.$route.params.groupID}/convidar`)
    }, */

    goToGroups () {
      this.$router.push('/admin/grupos/')
    },

    /**
     *
     * HANDLE SCALE CREATE MODAL
     *
     */

    openScaleCreateModal (group) {
      // console.log('::: openScaleCreateModal:', group)

      const groupScalesAmount = !!this.groupScales === true && Array.isArray(this.groupScales) ? this.groupScales.length : 0

      const limiteEscalas = Number(this.userSession.userCapabilities.limiteEscalas)

      if (freeVersion === false && groupScalesAmount >= limiteEscalas)
      {
        const planName = this.userSession.planName.name

        const textSupport = `<p>Por favor, converse com o nosso <a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo criar escalas. Preciso de ajuda." target="_blank">suporte</a> e saiba como aumentar o limite de escalas.</p>`

        if (this.userSession.planOrigin === 'CUSTOM') {
          // Plano personalizado
          this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'COUPON') {
          // Cupom ativo
          this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo, mas atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
          // Assinatura ativa na vindi
          this.openSubscriptionModal('Faça um upgrade', `<p>Você atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'} no ${planName}.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
          // Assinatura ativa, mas com alguma pendência ou erro na vindi
          this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e você atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
        } else {
          if (!!this.userSession.vindi === true) {
            // Plano da vindi expirado
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
          } else {
            // Plano gratuíto ou alcançou alguma condição desconhecida
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e atingiu o limite de ${limiteEscalas} ${limiteEscalas === 1 ? ' escala concedida' : ' escalas concedidas'}.</p>${textSupport}`)
          }
        }

        return false
      }

      this.$refs.mdScaleCreate.open(group)
    },

    closeScaleCreateModal (action) {
      // [24/01/25] console.log('::: closeScaleCreateModal[action]:', action)
    },

    /* openScaleModal () {
      // [24/01/25] console.log('open Scale Modal')
      this.activeScaleModal = true
    },

    closeSubscriptionModal: function () {
      // [24/01/25] console.log('close Scale Modal')
      this.activeScaleModal = false
    }, */

    /**
     *
     * HANDLE SCALE EDIT DIALOG (ALTERAR DETALHES DA ESCALA)
     *
     */

    openScaleEditModal (selectedScale) {
      // [24/01/25] console.log('::: openScaleEditModal:', selectedScale)
      this.$refs.mdScaleEdit.open(selectedScale, this.group)
    },

    closeScaleEditModal (action) {
      // [24/01/25] console.log('::: closeScaleEditModal[action]:', action)
    },

    /**
     *
     * APAGAR ESCALA
     *
     */

    confirmScaleDelete (selectedScale) {
      // [24/01/25] console.log('::: confirmScaleDelete:', selectedScale)
      this.showDialog('Atenção!', 'A escala "<i><b style="color: green; word-break: break-all">' + selectedScale.scaleName + '</b></i>" e todos os dados relacionados serão apagados.<br><br><b style="color: indianred">ESSA AÇÃO É IRREVERSÍVEL!</b><br><br><b>Deseja continuar?</b>', 'scaleDelete', selectedScale)
    },

    /**
     *
     * RENOVAR LINK DA ESCALA
     *
     */

    confirmScaleLinkRenew (selectedScale) {
      this.showDialog('Atenção!', 'O link atual da escala "<i><b style="color: green; word-break: break-all">' + selectedScale.scaleName + '</b></i>" vai expirar.<br><br><b style="color: indianred">ENVIE O NOVO LINK PARA A SUA EQUIPE APÓS CONFIRMAR A OPERAÇÃO!</b><br><br><b>Deseja continuar?</b>', 'scaleLinkRenewal', selectedScale)
    },

    /**
     *
     * ACEITAR PLANTÃO SINALIZADO
     *
     */

    confirmDutyAccept (duty) {
      if (this.actionLoading === true) {
        // [24/01/25] console.log('::: o sistema está ocupado! não é possível aceitar o plantão no momento...')
        return false
      }

      // [24/01/25] console.log('confirmDutyAccept:', duty)

      this.showDialog('Atenção!', 'Este plantão será incluído na escala e nos relatórios do usuário.<br><b>Deseja continuar?</b>', 'dutyAccept', duty)
    },

    /**
     *
     * RECUSAR PLANTÃO SINALIZADO
     *
     */

    confirmDutyRefuse (duty) {
      if (this.actionLoading === true) {
        // [24/01/25] console.log('::: o sistema está ocupado! não é possível recusar o plantão no momento...')
        return false
      }

      // [24/01/25] console.log('confirmDutyRefuse:', duty)

      this.showDialog('Atenção!', 'Este plantão será recusado.<br><b>Deseja continuar?</b>', 'dutyRefuse', duty)
    },

    /**
     *
     * RETIRAR USUÁRIO DO GRUPO
     *
     */

    kickUserConfirm (userID, isMe, userName) {
      if (isMe === true) {
        // [24/01/25] console.log('::: você não pode retirar a si mesmo da gestão do grupo')
        return false
      }

      if (this.allLoadingUsers[userID] === true || this.actionLoading === true) {
        // [24/01/25] console.log('::: o sistema está ocupado! não pode retirar o usuário agora...')
        return false
      }

      // [24/01/25] console.log('kickUserConfirm:', userName)

      this.showDialog('Atenção!', `${userName} será retirado(a) do grupo. <b>Deseja continuar?</b>`, 'kickUser', { userID, isMe })
    },

    /**
     *
     * GERENCIAR AÇÕES DO CONFIRM-DIALOG
     *
     */

    async cdAction (cdResponse)
    {
      // [24/01/25] console.log('cdAction:', cdResponse)

      if (cdResponse === false) return

      const type = cdResponse.cdType
      const data = cdResponse.cdData

      /**
       *
       * APAGAR ESCALA
       *
       */

      if (type === 'scaleDelete') {
        if (this.actionLoading === true) {
          // [24/01/25] console.log('::: o sistema está ocupado! não é possível apagar a escala no momento...')
          return false
        }

        // [24/01/25] console.log(`::: APAGANDO A ESCALA "${data.scaleID}" DO GRUPO "${this.$route.params.groupID}"...`)

        this.actionLoading = true
        const request = await apiDeleteScale(this.$route.params.groupID, data.scaleID) // this.$route.params.groupID
        this.actionLoading = false

        // [24/01/25] console.log('::: scaleDelete -> result:', request)

        if (request.code === 0) {
          this.showMessage('Atenção!', request.response)
        } else {
          // this.close(true)
        }
      }

      /**
       *
       * RENOVAR LINK DA ESCALA
       *
       */

      if (type === 'scaleLinkRenewal') {
        if (this.actionLoading === true) {
          // console.log('::: o sistema está ocupado! não é possível renovar o link da escala no momento...')
          return false
        }

        // console.log(`::: RENOVANDO O LINK DA ESCALA "${data.scaleID}" DO GRUPO "${this.$route.params.groupID}"...`)

        this.actionLoading = true
        const request = await apiRenewScaleLink(this.$route.params.groupID, data.scaleID)
        this.actionLoading = false

        // console.log('::: scaleLinkRenewal -> result:', request)

        this.showMessage(request.title, request.response)
      }

      /**
       *
       * RENOVAR LINK DO GRUPO
       *
       */

      if (type === 'groupLinkRenewal') {
        if (this.actionLoading === true) {
          // console.log('::: o sistema está ocupado! não é possível renovar o link do grupo no momento...')
          return false
        }

        // console.log(`::: RENOVANDO O LINK DO GRUPO "${this.$route.params.groupID}"...`)

        this.actionLoading = true
        const request = await apiRenewGroupLink(this.$route.params.groupID)
        this.actionLoading = false

        // console.log('::: groupLinkRenewal -> result:', request)

        this.showMessage(request.title, request.response)
      }

      /**
       *
       * RECUSAR PLANTÃO DISPONÍVEL
       *
       */

      if (type === 'dutyRefuse') {
        if (this.actionLoading === true) {
          // [24/01/25] console.log('::: o sistema está ocupado! não é possível recusar o plantão no momento...')
          return false
        }

        //

        // [24/01/25] console.log('dutyRefuse:', data.dutyScaleValue, typeof data, data)

        //

        // [24/01/25] console.log(`::: RECUSANDO O PLANTÃO SINALIZADO "${data.waitingDutyID}"...`)

        // this.actionLoading = true

        apiSetWaitingDutyStatus(data.waitingDutyID, 2, data, response => {
          // this.actionLoading = false

          if (response.code === 0) {
            // [24/01/25] console.log(`::: NÃO FOI POSSÍVEL RECUSAR O PLANTÃO DISPONÍVEL ${data.waitingDutyID}`, response)
          } else {
            // [24/01/25] console.log(`::: O PLANTÃO DISPONÍVEL ${data.waitingDutyID} FOI RECUSADO`, response)
          }
        })
      }

      /**
       *
       * ACEITAR PLANTÃO DISPONÍVEL
       *
       */

      if (type === 'dutyAcceptConfirm')
      {
        if (this.actionLoading === true) {
          // [24/01/25] console.log('::: o sistema está ocupado! não é possível aceitar o plantão no momento...')
          return false
        }

        //

        // [24/01/25] console.log('dutyAcceptConfirm:', data.dutyScaleValue, typeof data, data)

        //
        //
        //

        const time = data.dutyTime.split(':')
        const hour = time[0]
        const minute = time[1]

        const horaBase = minute === '00' ? parseInt(hour) : data.dutyTime
        const durationBase = data.dutyDuration.length === 2 ? parseInt(data.dutyDuration) : data.dutyDuration

        //

        data.horaBase = horaBase
        data.durationBase = durationBase

        const dutyStartDateBase = moment(data.dutyDate, 'YYYY-MM-DD')
        data.dataInicioFmt = dutyStartDateBase.format('YYYY-M-D')
        data.dutyDateMsg = dutyStartDateBase.format('DD/MM/YYYY')

        //

        // [24/01/25] console.log(`::: ACEITANDO O PLANTÃO SINALIZADO "${data.waitingDutyID}"...`, data.dutyScaleValue, data)

        // this.actionLoading = true

        apiSetWaitingDutyStatus(data.waitingDutyID, 1, data, response => {
          // this.actionLoading = false

          if (response.code === 0) {
            // [24/01/25] console.log(`::: NÃO FOI POSSÍVEL ACEITAR O PLANTÃO DISPONÍVEL ${data.waitingDutyID}`, response)
          } else {
            // [24/01/25] console.log(`::: O PLANTÃO DISPONÍVEL ${data.waitingDutyID} FOI ACEITO`, response)
          }
        })
      }

      if (type === 'dutyAccept')
      {
        if (this.actionLoading === true) {
          // [24/01/25] console.log('::: o sistema está ocupado! não é possível aceitar o plantão no momento...')
          return false
        }

        //

        // [24/01/25] console.log('dutyAccept:', data.dutyScaleValue, typeof data, data)

        //
        //
        //
        // ------------------------------------------------------------------------------------------------
        // CONFLITOS (BEGIN)
        // ------------------------------------------------------------------------------------------------
        //
        //
        //

        const dataInicioPlantao = data.dutyDate.split('-')
        const dutyStartTime = valueToTime(data.dutyTime)

        //

        const selectedYear = Number(dataInicioPlantao[0])
        const selectedMonth = Number(dataInicioPlantao[1]) - 1

        const firstDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).startOf('day')
        const lastDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).endOf('month')

        // [24/01/25] console.log('::: selectedYear, selectedMonth:', selectedYear, selectedMonth)
        // [24/01/25] console.log('::: firstDate:', firstDate.format('YYYY-MM-DD HH:mm:ss'))
        // [24/01/25] console.log('::: lastDate:', lastDate.format('YYYY-MM-DD HH:mm:ss'))

        //
        //
        //
        // Mostra conflitos caso algum usuário tenha outro plantão no mesmo horário
        //
        //
        //

        // data.dutyGroupID
        const { conflictedScales = [], conflictsTableHtml = '' } = await canAddUserShift(dutyStartTime, [`${dataInicioPlantao[2]}/${dataInicioPlantao[1]}/${dataInicioPlantao[0]}`], /* this.listeners.groupScales, */ data.dutyCreatorID, firstDate, lastDate)

        if (conflictedScales.length > 0)
        {
          // this.loading = false

          const ownerName = data.dutyCreatorName.trim()
          const plantonistaText = ownerName.length > 0 ? `<b style="color: #778899">${ownerName}</b>` : 'O usuário'

          const text = `<div style="text-align: center">${plantonistaText} já tem um plantão nesse mesmo dia e horário.<br /><br />Veja os conflitos abaixo:<br /><br />${conflictsTableHtml}<br /><b>Deseja aceitar o plantão mesmo assim?</b></div>`
          this.showConfirmBox({
            title: 'Conflito!',
            text,
            type: 'dutyAcceptConfirm',
            data,
            isResponse: false,
            buttonPosition: 'right',
            width: 330,
            closeText: 'Não',
            continueText: 'Sim',
          })

          // Veja as escalas abaixo e resolva os conflitos para continuar

          // const text = `<div style="text-align: center">${plantonistaText} já tem um plantão nesse mesmo dia e horário.<br /><br />Resolva os conflitos abaixo:<br /><br />${conflictsTableHtml}</div>`
          // this.showMessage('Conflito!', text)

          // showDialog: function (title, text, type, data, isResponse = false, buttonPosition = 'right', width = 330) {

          // this.showDialog('Conflito!', text, 'dutyAcceptConfirm', data)

          return false
        }

        //
        //
        //
        // ------------------------------------------------------------------------------------------------
        // CONFLITOS (END)
        // ------------------------------------------------------------------------------------------------
        //
        //
        //

        const time = data.dutyTime.split(':')
        const hour = time[0]
        const minute = time[1]

        const horaBase = minute === '00' ? parseInt(hour) : data.dutyTime
        const durationBase = data.dutyDuration.length === 2 ? parseInt(data.dutyDuration) : data.dutyDuration

        //

        data.horaBase = horaBase
        data.durationBase = durationBase

        const dutyStartDateBase = moment(data.dutyDate, 'YYYY-MM-DD')
        data.dataInicioFmt = dutyStartDateBase.format('YYYY-M-D')
        data.dutyDateMsg = dutyStartDateBase.format('DD/MM/YYYY')

        //

        // [24/01/25] console.log(`::: ACEITANDO O PLANTÃO SINALIZADO "${data.waitingDutyID}"...`, data.dutyScaleValue, data)

        // this.actionLoading = true

        apiSetWaitingDutyStatus(data.waitingDutyID, 1, data, response => {
          // this.actionLoading = false

          if (response.code === 0) {
            // [24/01/25] console.log(`::: NÃO FOI POSSÍVEL ACEITAR O PLANTÃO DISPONÍVEL ${data.waitingDutyID}`, response)
          } else {
            // [24/01/25] console.log(`::: O PLANTÃO DISPONÍVEL ${data.waitingDutyID} FOI ACEITO`, response)
          }
        })
      }

      /**
       *
       * RETIRAR USUÁRIO DO GRUPO
       *
       */

      if (type === 'kickUser') {
        if (data.isMe === true) {
          // [24/01/25] console.log('::: você não pode retirar a si mesmo da gestão do grupo')
          return false
        }

        if (this.allLoadingUsers[data.userID] === true || this.actionLoading === true) {
          // [24/01/25] console.log('::: o sistema está ocupado! não pode retirar o usuário agora...')
          return false
        }

        /* SEM MENSAGEM PARA O GRUPO */
        // targetUserId, nome,

        // [24/01/25] console.log(`::: RETIRANDO O USUÁRIO ${data.userID} DO GRUPO...`)

        this.actionLoading = true

        this.allLoadingUsers[data.userID] = true
        this.allLoadingUsers = { ...this.allLoadingUsers }

        apiRemoveUserFromGroup(data.userID, this.$route.params.groupID,
        response => {
          this.isAdmin[data.userID] = false
          this.isMaster[data.userID] = false

          this.allLoadingUsers[data.userID] = false
          this.allLoadingUsers = { ...this.allLoadingUsers }

          this.actionLoading = false

          if (response.code === 0) {
            // [24/01/25] console.log(`::: NÃO FOI POSSÍVEL RETIRAR O USUÁRIO ${data.userID} DO GRUPO:`, this.isAdmin[data.userID], this.isMaster[data.userID], response)
          } else {
            // [24/01/25] console.log(`::: O USUÁRIO ${data.userID} FOI RETIRADO DO GRUPO:`, this.isAdmin[data.userID], this.isMaster[data.userID], response)
          }
        })
      }
    },

    //
    //
    //
    // ?
    //
    //
    //

    async onSelectScale (optionValue, optionText, optionPayload)
    {
      // [24/01/25] console.log('::: onSelectScale:', { optionValue, optionText, optionPayload })

      if (!!optionPayload === false) return false

      const uid = optionPayload.userID
      const scaleID = optionPayload.scaleID

      // console.log('::: onSelectScale > groupUsersScales[uid]:', this.groupUsersScales[uid])

      if (!!this.groupUsersScales[uid] === false) return false

      const foundCheck = this.groupUsersScales[uid].find(i => i.value === optionValue)
      // console.log(`::: onSelectScale[${uid}] > groupUsersScales[uid]:`, this.groupUsersScales[uid])
      // console.log(`::: onSelectScale[${uid}] > foundCheck:`, foundCheck)
      if (!!foundCheck === false) return false

      const foundScale = this.groupScales.find(groupScale => groupScale.scaleID === scaleID)
      // console.log(`::: onSelectScale[${uid}] > foundScale:`, foundScale)
      if (!!foundScale === false) return false

      this.allLoadingUsers[uid] = true
      this.allLoadingUsers = { ...this.allLoadingUsers }

      // console.log(`::: onSelectScale[${uid}] > ${scaleID} > scaleRelatedUsers:`, foundScale.scaleRelatedUsers)

      foundCheck.checked = !foundCheck.checked

      // Add or remove userID from RELATED USERS LIST in THE SELECTED SCALE
      const newUsers = foundCheck.checked === true ? [...foundScale.scaleRelatedUsers, uid] : foundScale.scaleRelatedUsers.filter(relatedUserID => relatedUserID !== uid)

      // console.log(`::: onSelectScale[${uid}] > newUsers:`, newUsers)

      await apiSetUserScales(this.$route.params.groupID, scaleID, newUsers)
      // [24/01/25] const request = await apiSetUserScales(this.$route.params.groupID, scaleID, newUsers)

      // [24/01/25] console.log(`::: onSelectScale[${uid}] > request:`, request)

      //
      // Atualizar o grupo de municípios reativamente
      //

      //
      // this.$set(this.groupUsersScales, userID, newScales)
      //
    },

    requestGroupUsersReport ()
    {
      this.$refs.dialogReportExport.open(`${reportUrl}/reports/groupusers_stream/${this.groupID}`)
    },
  },
}
